import { FC, useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $generateHtmlFromNodes } from '@lexical/html';

export const ExportPlugin: FC<{
    exportAsHTML?: (contentAsHTML: string) => void;
    exportAsJSON?: (contentAsJSON: string) => void;
}> = ({
    exportAsHTML,
    exportAsJSON
}) => {
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        if (exportAsHTML) {
            editor.registerUpdateListener(() => {
                editor.update(() => {
                    const contentAsHTML = $generateHtmlFromNodes(editor);
                    exportAsHTML(contentAsHTML);
                });
            });
        }
    }, [editor, exportAsHTML]);

    useEffect(() => {
        if (exportAsJSON) {
            editor.registerUpdateListener(({ editorState }) => {
                editorState.read(() => {
                    const contentAsJSON = JSON.stringify(editorState.toJSON());
                    exportAsJSON(contentAsJSON);
                });
            });
        }
    }, [editor, exportAsJSON]);

    return null;
};

export default ExportPlugin;